import { Helmet } from 'react-helmet-async';

const SEOHead = ({ 
  title = 'The Gem Atelier | Luxury Gemstones',
  description = 'The Gem Atelier - Curators of Exceptional Gems. Discover exquisite gemstones and fine jewelry.',
  image = 'https://customer-assets.emergentagent.com/job_3b35c559-07b5-4fd8-a210-8ba78c0ad2dc/artifacts/57qw7w56_F683E346-12CC-4A47-A850-08225E60D944.png',
  url,
  type = 'website',
  productPrice,
  productCurrency = 'USD'
}) => {
  const siteUrl = url || window.location.href;
  
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={siteUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content="The Gem Atelier" />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={siteUrl} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />

      {/* Product Specific (for e-commerce) */}
      {type === 'product' && productPrice && (
        <>
          <meta property="product:price:amount" content={productPrice} />
          <meta property="product:price:currency" content={productCurrency} />
        </>
      )}
    </Helmet>
  );
};

export default SEOHead;
